import { render } from "./AppRema.vue?vue&type=template&id=7008a7c8&scoped=true"
import script from "./AppRema.vue?vue&type=script&lang=js"
export * from "./AppRema.vue?vue&type=script&lang=js"

import "./AppRema.vue?vue&type=style&index=0&id=7008a7c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7008a7c8"]])

export default __exports__